import React, { memo } from "react";

/**
 * Page skeleton loading component
 * Using React.memo since this is a pure component
 */
const PageSkeleton = memo(function PageSkeleton(): React.ReactElement {
    return (
        <div
            className="animate-pulse p-6 max-w-4xl mx-auto"
            role="status"
            aria-busy="true"
            aria-label="Loading page content"
        >
            {/* Title skeleton */}
            <div className="h-10 bg-gray-200 rounded-lg w-1/3 mb-6 dark:bg-gray-700"></div>

            {/* Content skeleton */}
            <div className="space-y-4">
                <div className="h-4 bg-gray-200 rounded w-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded w-4/6 dark:bg-gray-700"></div>
            </div>

            {/* Card skeleton */}
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                {[1, 2].map((i) => (
                    <div key={i} className="border rounded-lg p-4 dark:border-gray-700">
                        <div className="h-6 bg-gray-200 rounded w-1/2 mb-4 dark:bg-gray-700"></div>
                        <div className="h-4 bg-gray-200 rounded w-full mb-2 dark:bg-gray-700"></div>
                        <div className="h-4 bg-gray-200 rounded w-3/4 dark:bg-gray-700"></div>
                    </div>
                ))}
            </div>

            <span className="sr-only">Loading...</span>
        </div>
    );
});

export default PageSkeleton;
